<mat-card class="mat-card">
    <highcharts-chart [Highcharts]="highcharts" [options]="chartOptions" [(update)]="updateFlag"
        style="width: 100%; height:100%; display: block;">
    </highcharts-chart>
</mat-card>
